import { render, staticRenderFns } from "./CommunityEducators.vue?vue&type=template&id=cbee601a&scoped=true&"
import script from "./CommunityEducators.vue?vue&type=script&lang=js&"
export * from "./CommunityEducators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbee601a",
  null
  
)

export default component.exports